import type { LogMessage } from "./useWebContainerHook";

import * as React from "react";
import { useRef } from "react";

import { toast } from "@replo/design-system/components/alert/Toast";
import Button from "@replo/design-system/components/button/Button";

import { useWebContainer } from "./context";

const formatLogMessage = (log: LogMessage) => {
  return `${log.date.toLocaleTimeString()} ${log.message}`;
};

const WebContainerLogs = () => {
  const { logs } = useWebContainer();

  const logsRef = useRef<HTMLPreElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want to scroll to the bottom of the logs when they change
  React.useEffect(() => {
    if (logsRef.current) {
      logsRef.current?.scrollTo({
        top: logsRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [logs]);

  return (
    <div className="fixed bottom-0 left-0 z-50 right-0 bg-white flex rounded flex-col border-1">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => {
          void navigator.clipboard
            .writeText(
              logs.map(formatLogMessage).join("\n").replaceAll(/\n+/g, "\n"),
            )
            .then(() => {
              toast({
                header: "Logs copied to clipboard",
              });
            });
        }}
        layoutClassName="absolute right-8 top-2"
      >
        Copy Logs
      </Button>
      <pre
        ref={logsRef}
        className={
          // eslint-disable-next-line replo/no-tailwind-literal-color
          "h-96 overflow-x-auto overflow-y-auto rounded bg-black p-2 text-xs text-green-400"
        }
      >
        {logs.map((log, index) => (
          <div key={index}>{formatLogMessage(log)}</div>
        ))}
      </pre>
    </div>
  );
};

export default WebContainerLogs;
